import React, { useState, useEffect } from "react";
import "antd/dist/antd.css";
import { Input, Select } from "antd";
import { BsCheck2 } from "react-icons/bs";
//
export default function IconInput(props) {
  const {
    label,
    value,
    onChangeText,
    prefix,
    placeholder,
    type,
    loading,
    required,
    invalid,
    errorText,
  } = props;
  const onChangeHandler = (e) => {
    onChangeText(e.target.value);
  };
  const fieldClass = [
    "dropdown_wrapper",
    "pi-form-field",
    invalid ? "is-invalid" : "",
  ]
    .filter(Boolean)
    .join(" ");
  return (
    <div className={fieldClass}>
      <label className="pi-form-field__label">
        {label}
        {required ? (
          <span className="pi-form-field__required" aria-hidden="true">
            *
          </span>
        ) : null}
      </label>
      <Input
        className={`pi-form-input${invalid ? " is-invalid" : ""}`}
        disabled={loading}
        type={type}
        placeholder={placeholder || label}
        prefix={prefix}
        onChange={onChangeHandler}
        value={value}
        aria-required={required ? "true" : undefined}
        aria-invalid={invalid ? "true" : undefined}
      />
      {invalid && errorText ? (
        <p className="pi-form-field__error" role="alert">
          {errorText}
        </p>
      ) : null}
    </div>
  );
}
